<style src="./EmployeeNotificationDailyResume.scss" lang="scss"></style>
<template>
  <section
    class="
      employee-notification-daily-resume
      wrapper wrapper-content
      animated
      fadeInRight
    "
  >
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="generateReport">
        <div class="formContainer">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="col-sm-6">Colaborador</label>
              <select class="form-control m-b" v-model="form.employeeId">
                <option
                  v-for="(item, idx) in employeeList"
                  :key="idx"
                  :value="item.id"
                >
                  {{ item.fullName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Início</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  class="form-control"
                  v-model="form.startDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Fim</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  class="form-control"
                  v-model="form.endDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Gerar Relatório
            </button>
          </div>
        </div>
      </form>
    </div>

    <template v-if="reportDetails">
      <section class="row result" v-if="reportDetails">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content table-responsive">
              <table class="table table-hover no-margins">
                <thead>
                  <tr>
                    <th>Monitor</th>
                    <th>Setor</th>
                    <th>Primeira Hora</th>
                    <th>Hora Seguinte</th>
                    <th>Veículos</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(elementResult, elementResultIdx) in reportDetails"
                    :key="elementResultIdx"
                  >
                    <td>{{ elementResult.employee }}</td>
                    <td>{{ elementResult.parkName }}</td>
                    <td>{{ elementResult.firstHour }}</td>
                    <td>{{ elementResult.sequenceHour }}</td>
                    <td>{{ elementResult.vehicleCount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </template>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  name: 'EmployeeNotificationDailyResume',
  data: () => ({
    showSpinner: false,
    form: {
      employeeId: '',
      startDate: new Date(),
      endDate: new Date(),
    },
    employeeList: [],
    reportDetails: null,
  }),
  filters: {
    totalToCurrencyBR(value) {
      if (!value) {
        return '0,00';
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours).toString().padStart(2, '0');
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes).toString().padStart(2, '0');
      return `${rhours}:${rminutes}`;
    },
  },
  mounted() {
    this.listEmployee();
    this.form.startDate = moment(new Date()).format('YYYY-MM-DD');
    this.form.endDate = moment(new Date()).format('YYYY-MM-DD');
  },
  methods: {
    async listEmployee() {
      const employeeListFull = await this.$store.dispatch(
        'EMPLOYEE/GetEmployeeList',
      );
      const employeeList = employeeListFull.map((item) => ({
        id: item._id,
        fullName: item.fullName,
      }));
      this.employeeList = employeeList;
    },
    async generateReport() {
      const query = {
        employeeId: this.form.employeeId,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
      };

      const reportResult = await this.$store.dispatch(
        'REPORTS/EmployeeNotificationDailyResume',
        { query },
      );
      this.reportDetails = reportResult;
    },
  },
};
</script>